<template>
  <v-hover v-slot="{ hover }" close-delay="200">
    <v-text-field v-model="modelValue" :readonly="readonly" class="q-input"
      :class="[BorderClass, CompactClass, BlurrClass, InputColorClass]" :background-color="BackgroundColor"
      :label="labelText" :type="type ? type : undefined" hide-details="auto" :disabled="IsDisabled"
      :clearable="!IsEmpty && clearable" :single-line="singleline" :color="color" :rules="rules"
      :error="hasManualErrors" :error-messages="errormessages" :hoverbool="setHoverBool(hover)" :suffix="suffix"
      :prefix="prefix" :persistentHint="persistentHint" :reverse="reverse"
      :counter="counter || (!readonly && maxlength && charLimitAproximation(modelValue, maxlength))" :maxlength="maxlength"
      :hint="hint" @change="(args) => $emit('change', args)" :placeholder="placeholderText" persistent-placeholder flat
      @focus="setEdit" @blur="blurInput" @update:error="onErrorChange" @keypress="editKeyPress" @keydown="editKeyDown">

      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend-outer" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend" />
      </template>
      <!------------------->

      <!-- APPEND SLOTS -->
      <template v-slot:append>
        <slot name="append">
          <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="primary">
          </v-progress-circular>
          <LockedWarning v-else-if="disabled" :hover="hover" />
          <ExternalChangeWarning v-if="!allowexternaloverride && externallychanged"
            @Sync="(newValue = value, externallychanged = false)" />
        </slot>
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
      <!------------------->

    </v-text-field>
  </v-hover>
</template>


<script>
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";
import LockedWarning from "@/components/Inputs/Parts/LockedWarning.vue";
import InputMixin from "@/helpers/Mixins/InputMixin";

export default {
  name: "QTextField",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: [Object, String, Number, Array],
    list: Array,
    type: String,
    multiple: Boolean,
    hint: String,
    color: String,
    backgroundcolor: String,
    singleline: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    persistentHint: Boolean,
    placeholder: [String, Object],
    rules: Array,
    errormessages: Array,
    allowexternaloverride: Boolean,
    timestampOnFirstLineEnter: Boolean,
    reverse: Boolean,
    counter: [Boolean, Number, String],
    maxlength: [Number, String],
    suffix: String,
    prefix: String,
  },
  components: {
    LockedWarning,
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      error: false,
      edit: false,
      newValue: this.value,
    };
  },

  methods: {
    onErrorChange(e) {
      this.error = e;
      this.$emit("Error", e);
    },

    charLimitAproximation(value, limit) {
      var tippingpoint = parseInt(limit) * 0.75;
      return !!(value && (value.length > tippingpoint));
    },
  },

  computed: {
    hasManualErrors() {
      var has = this.errormessages && (this.errormessages.length > 0)
      return has;
    },

    readonly() {
      return !this.externaledit && (this.IsDisabled || !this.edit);
    },
  },

  watch: {},
};
</script>


<style scoped></style>
